import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, withModifiers as _withModifiers, withKeys as _withKeys, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("button", {
    class: _normalizeClass(["shadow-lg inline-flex border-2 focus:outline-none select-none whitespace-nowrap", [_ctx.isLightMode() ? _ctx.lightModeClasses : _ctx.darkModeClasses, { 'cursor-not-allowed': _ctx.disabled }]]),
    disabled: _ctx.disabled,
    style: _normalizeStyle(`padding: ${_ctx.padding_top}px ${_ctx.padding_right}px ${_ctx.padding_bottom}px ${_ctx.padding_left}px; border-radius: ${_ctx.border_radius}rem; font-weight: ${_ctx.font_weight}; transition:background 0.25s;`),
    onKeydown: _cache[0] || (_cache[0] = _withKeys(_withModifiers(($event: any) => (_ctx.click()), ["exact","prevent"]), ["enter"]))
  }, [
    _createElementVNode("span", {
      class: _normalizeClass(["material-icons my-auto px-1", `${_ctx.iconSize} ${_ctx.iconColor}`])
    }, _toDisplayString(_ctx.icon), 3),
    _createElementVNode("div", {
      class: _normalizeClass(["pr-2 my-auto", `${_ctx.textSize}`])
    }, _toDisplayString(_ctx.text), 3)
  ], 46, _hoisted_1))
}